import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pisalo",
  "description": "",
  "published": "2006-11-23T00:00:00.000Z",
  "redirect_from": ["/blog/pisalo/swizec/349"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Obstajajo ljudje, ki jim je pravzaprav vseeno kaksno pisalo uporabljajo, samo da pise v pravi barvi. Potem pa so tu se ljudje, ki jim je zelo pomembno kaksno pisalo imajo. Osebno spadam v drugo vrsto, ne vem zakaj tocno, ampak opazam, da z uporabo tocno dolocenega pisala tocno dolocene debeline pride do preprosto najboljsih rezultatov. Danes je pisalo umrlo. Res je, take stvari se pac dogajajo, nic posebnega. Ampak kdo bi si lahko mislil, da je tako tezko priti do zeljenega pisala.`}</p>
    <p>{`Najprej sem sel v trgovino, kjer ponavadi rastejo in se razmnozujejo. Na zalost jim je zmanjkalo prave debeline, zato sem sel v drugo, kjer jih sploh nimajo, v tretji pa sem koncno dobil iskano ...`}</p>
    <p>{`Se nekaj zelo zanimivega se je zgodilo danes, v posti me je pricakalo prav lepo vabilo na nek literarni natecaj za kratko zgodbico. Bil sem prijetno presenecen in ker zahtevajo 1000 besed dolgo zgodbo na doloceno temo, jo bodo seveda tudi dobili.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      